<template>
  <v-row justify="center">
    <v-dialog
      v-model="mostrarModal"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>
          {{ $t('modal.titulo') }}
        </v-card-title>
        <v-divider />
        <v-card-text style="height: 300px;">
          <p>
            {{ $t('modal.description') }}
          </p>
          <v-radio-group
            v-model="referencia"
            column
          >
            <v-radio
              v-for="(item, i) in referencias"
              :key="i"
              :label="`Referencia ${item.numeroReferencia}: ${item.observaciones}`"
              :value="item"
            />
          </v-radio-group>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="enviarDatos"
          >
            {{ $t('modal.aceptar') }}
          </v-btn>
          <v-btn
            color="darken-1"
            text
            @click="mostrarModal = false"
          >
            {{ $t('modal.cerrar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'ModalReferencias',
  props: {
    referencias: {
      type: Array,
      default: () => {},
      description: 'Contiene todas las obras a mostrar en la lista desplegable'
    }
  },
  data () {
    return {
      mostrarModal: false,
      referencia: null
    }
  },
  methods: {
    enviarDatos () {
      this.$emit('llenar-formulario', this.referencia)
      this.mostrarModal = false
    }
  }
}
</script>

<style>

</style>

<i18n>
{
  "es": {
    "modal": {
      "titulo": "Seleccione el pago a realizar",
      "description": "Se encontraron múltiples pagos referenciados para este número de documento, por favor seleccione el pago que desea realizar",
      "cerrar": "Cancelar",
      "aceptar": "Aceptar"
    }
  }
}
</i18n>
